import { useState } from "react";
import { TextField } from "@mui/material";
import html2canvas from "html2canvas";
import _ from "lodash";
import "../Analyze/data/Data.css";
import { API_URL as baseApiUrl } from "@/config/env";

export const durationList = [
	{ value: 3, label: "Last 3 Months" },
	{ value: 6, label: "Last 6 Months" },
	{ value: 9, label: "Last 9 Months" },
	{ value: 12, label: "Last 12 Months" },
	{ value: 24, label: "Last 24 Months" },
	{ value: 36, label: "Last 36 Months" },
];

export const valueTypeList = [
	{ value: "Abs", label: "Absolute" },
	{ value: "Per", label: "Percent" },
];

export const sizes = {
	w650: 650,
	w450: 450,
	w300: 300,
	w270: 270,
	w250: 250,
	w200: 200,
	w150: 150,
	h35: 35,
};

export const Apis = {
	analysisTypes: baseApiUrl + "Analyze/GetAnalysisType",
	userCountries: baseApiUrl + "GetUserCountries?",
	scenariosForCountry: baseApiUrl + "Analyze/GetScenarios?",
	skuPGForScenario: baseApiUrl + "Analyze/GetSKUOrPGByScenario?",
	chartData: baseApiUrl + "Analyze/GetAnalyzeDataChartData?",
	exportFile: baseApiUrl + "Analyze/ExportFile?",
	newCustomerData: baseApiUrl + "Analyze/GetAnalyzeNewCustomerData?",
	customersByScenario: baseApiUrl + "Analyze/GetCustomerbyScenario?",
	customerChartData: baseApiUrl + "Analyze/GetAnalyzeCustomerData?",
	scenarioChartData: baseApiUrl + "Analyze/GetParentChildScenarioDetails?",
	getCustomersIncludedExcludedDetails:
		baseApiUrl + "Analyze/GetCustomersIncludedExcludedDetails?",
	customersByCountry: baseApiUrl + "Analyze/GetCustomerbyCountry?",
	durations: baseApiUrl + "Analyze/GetDurationForQuota",
	quotaDetailsData: baseApiUrl + "Admin/GetQuotaDetailsByCountry?",
	exportFileForQuotaDetails: baseApiUrl + "Analyze/ExportFileForQuotaDetails?",
	modificationsData: baseApiUrl + "Analyze/GetModifications?",
	periods: baseApiUrl + "Analyze/GetPeriods",
	fourPLexport: baseApiUrl + "Analyze/GetAnalyze4PLExportPartnerReport?",
	export4PLExportPartner: baseApiUrl + "Analyze/Export4PLExportPartner?",
	getAnalyzeTradeProducts: baseApiUrl + "Analyze/GetAnalyzeTradeProducts?",
	getAnalyzeTradeForm: baseApiUrl + "Analyze/GetAnalyzeTradeForm?",
	getAnalyzeTradeStrength: baseApiUrl + "Analyze/GetAnalyzeTradeStrength",
	getProductQuota: baseApiUrl + "Analyze/GetProductQuota",
	getAnalyzeCustomerName: baseApiUrl + "Analyze/GetAnalyzeCustomername_Rv3?",
	getAnalyzeIntendDeliveredChart:
		baseApiUrl + "Analyze/GetAnalyzeIntendDeliveredChart",
	getInDemandDataReport: baseApiUrl + "Admin/GetInDemandDataReport?",
	getFolderIdByName: baseApiUrl + "Moveit/GetFolderIdByName_Rv3?",
	getFolderContent: baseApiUrl + "Moveit/GetFolderContent?",
	exportInDemandReport: baseApiUrl + "Analyze/ExportInDemandReport?",
	downloadFile: baseApiUrl + "Moveit/DownloadFile?",
	getDatasources: baseApiUrl + "Admin/GetDatasources",
	getDatasourcesByCountry: baseApiUrl + "Scenario/GetDatasourcesByCountry?",
	exportBackendReport: baseApiUrl + "Analyze/ExportReport",
	updateIsCustomerReviewed: baseApiUrl + "Analyze/UpdateIsCustomerReviewed",
	addNewAnalyzeDataSource: baseApiUrl + "Analyze/AddNewAnalyzeDataSource",
	saveAnalyzeDataSource: baseApiUrl + "Analyze/SaveAnalyzeDataSource",
};

export function prepareMultiLineChartData(srcData) {
	let dataSources = getDataSources(srcData);
	let periods = getPeriods(srcData);
	let seriesData = [];
	for (let s = 0; s < dataSources.length; ++s) {
		const name = dataSources[s];
		let data = [];
		for (let i = 0; i < srcData.length; ++i) {
			if (srcData[i].series === name) {
				data.push(srcData[i].value);
			}
		}
		const item = {
			name,
			data,
		};
		seriesData.push(item);
	}

	const preparedData = {
		periods,
		seriesData,
	};
	return preparedData;
}

function getDataSources(data) {
	let series = [];
	let set = new Set();
	for (let i = 0; i < data.length; ++i) {
		set.add(data[i].series);
	}
	series = Array.from(set);
	return series;
}

function getPeriods(data) {
	let periods = [];
	let set = new Set();
	for (let i = 0; i < data.length; ++i) {
		set.add(data[i].period);
	}
	periods = Array.from(set);
	return periods;
}

export function prepareColumnChartData(data) {
	let categories = [];
	let values = [];
	for (let i = 0; i < data.length; ++i) {
		categories.push(data[i].series);
		values.push(data[i].value);
	}
	const preparedData = {
		categories,
		values,
	};
	return preparedData;
}

export function prepareTableData(data) {
	let preparedData = {};
	const rows = prepareTableRow(data);
	const columns = prepareTableColumn(data);
	preparedData.rows = rows;
	preparedData.columns = columns;
	return preparedData;
}

const AddDataSource = ({ params }) => {
	const [value, setValue] = useState("");
	if (params.row.isEditable) {
		return (
			<TextField
				type="text"
				value={value}
				onChange={(e) => setValue(e.target.value)}
			/>
		);
	} else {
		return <span>{params.value}</span>;
	}
};

function getTextPixelWidth(text, font = "14px Roboto, Arial, sans-serif") {
	const canvas =
		getTextPixelWidth.__canvas ||
		(getTextPixelWidth.__canvas = document.createElement("canvas"));
	const context = canvas.getContext("2d");
	context.font = font;
	return context.measureText(text ?? "").width;
}

function getMaxDataSourceWidth(data) {
	let max = 0;
	for (let i = 0; i < data.length; ++i) {
		const name = data[i]?.dataSourceName ?? "";
		const width = getTextPixelWidth(name);
		if (width > max) max = width;
	}
	// Add padding for cell gutters + sort icon spacing
	const paddingAndExtras = 48; // approx padding + icon space
	const computed = Math.ceil(max + paddingAndExtras);
	// Clamp to reasonable bounds
	const min = 150;
	const maxAllowed = 600;
	return Math.max(min, Math.min(computed, maxAllowed));
}

function prepareTableColumn(data) {
	const obj = data[0];
	const dataSourceWidth = getMaxDataSourceWidth(data);
	const columns = [
		// {
		//   field: 'checkbox',
		//   headerName: 'Select',
		//   width: 100,
		//   renderCell: (params) => (
		//     <DataCheckBox {...params}
		//     />
		//   ),
		// },
		{
			field: "col1",
			headerName: "Data Source",
			width: dataSourceWidth,
			renderCell: (params) => {
				return <AddDataSource params={params} />;
			},
			headerClassName: "sticky-header",
			cellClassName: "sticky-class",
		},
	];
	let colNum = 2;
	for (let prop in obj) {
		if (
			prop !== "dataSourceID" &&
			prop !== "dataSourceName" &&
			prop !== "localNo" &&
			prop !== "avgValue"
		) {
			const name = prop.toLocaleUpperCase();
			let item = {
				field: `col${colNum}`,
				headerName: name,
				flex: 1,
				minWidth: 150,
				renderCell: (params) => {
					return <AddDataSource params={params} />;
				},
			};
			columns.push(item);
			++colNum;
		}
	}
	let item = {
		field: `col${colNum}`,
		headerName: "Avg Value",
		flex: 1,
		minWidth: 150,
		renderCell: (params) => {
			return <AddDataSource params={params} />;
		},
	};
	columns.push(item);
	return columns;
}

function prepareTableRow(data) {
	const row = [];
	for (let i = 0; i < data.length; ++i) {
		let obj = data[i];
		let item = { id: i, col1: obj.dataSourceName };
		let colNum = 2;
		for (let prop in obj) {
			if (
				prop !== "dataSourceID" &&
				prop !== "dataSourceName" &&
				prop !== "localNo" &&
				prop !== "avgValue"
			) {
				item[`col${colNum}`] = obj[prop];
				++colNum;
			}
		}
		item[`col${colNum}`] = obj.avgValue;
		row.push(item);
	}
	return row;
}

export function catchElement(className) {
	const element = document.querySelector(className);
	if (!element) {
		console.log("Element not found");
		return;
	}
	return element;
}

export async function elementToBase64(element) {
	try {
		const canvas = await html2canvas(element);
		return canvas.toDataURL("image/png");
	} catch (error) {
		console.log(
			"An error occurred while converting the element to base64:",
			error
		);
		return null;
	}
}

export function prepareNewCustomerTableData(data) {
	let preparedData = {};
	const rows = prepareNewCustomerTableRow(data);
	const columns = prepareNewCustomerTableColumn();
	preparedData.rows = rows;
	preparedData.columns = columns;
	return preparedData;
}

function prepareNewCustomerTableColumn() {
	const columns = [
		{
			field: "customerName",
			headerName: "Customer Name",
			flex: 1,
			minWidth: 150,
		},
		{
			field: "customerNumber",
			headerName: "Customer Number",
			flex: 1,
			minWidth: 150,
		},
		{
			field: "customerLocation",
			headerName: "Customer Location",
			flex: 1,
			minWidth: 150,
		},
		{
			field: "dateOfAppearance",
			headerName: "Date of Appearance",
			flex: 1,
			minWidth: 150,
			sortComparator: (v1, v2) => {
				const date1 = parseCustomDate(v1);
				const date2 = parseCustomDate(v2);

				if (date1 < date2) {
					return -1;
				}
				if (date1 > date2) {
					return 1;
				}
				return 0;
			},
		},
		{
			field: "customerType",
			headerName: "Customer Type",
			flex: 1,
			minWidth: 150,
		},
		{
			field: "partnerType",
			headerName: "Partner Type",
			flex: 1,
			minWidth: 150,
		},
		{
			field: "numberOfOrders",
			headerName: "Number Of Orders",
			flex: 1,
			minWidth: 150,
		},
		{
			field: "isReviewed",
			headerName: "Is Reviewed",
			flex: 1,
			minWidth: 150,
			valueGetter: (params) => {
				return params.row.isReviewed === 1 ? "Yes" : "No";
			},
		},
	];
	return columns;
}
function parseCustomDate(dateString) {
	const parts = dateString.split(", ");
	const [dayOfWeek, monthDayYear, year] = parts;

	const [month, day] = monthDayYear.split(" ");
	const monthIndex = new Date(Date.parse(`${month} 1, 2000`)).getMonth();

	return new Date(year, monthIndex, day);
}

function prepareNewCustomerTableRow(data) {
	let rows = [];

	for (let i = 0; i < data.length; ++i) {
		let customer = data[i];
		const {
			customerID,
			customerName,
			customerNumber,
			customerLocation,
			dateOfAppearance,
			customerType,
			partnerType,
			numberOfOrders,
			isReviewed,
		} = customer;
		const obj = {
			customerID,
			customerName,
			customerNumber,
			customerLocation,
			dateOfAppearance: formatDate(dateOfAppearance),
			customerType,
			partnerType,
			numberOfOrders,
			isReviewed,
		};
		rows.push(obj);
	}
	return rows;
}

function formatDate(inputDate) {
	const date = new Date(inputDate);
	const options = {
		weekday: "short",
		month: "short",
		day: "numeric",
		year: "numeric",
	};

	return date.toLocaleDateString("en-US", options);
}

export function prepareCustomerTableData(data) {
	let preparedData = {};
	const rows = prepareCustomerTableRow(data);
	const columns = prepareCustomerTableColumn(data[0]);
	preparedData.rows = rows;
	preparedData.columns = columns;
	return preparedData;
}

function prepareCustomerTableColumn(obj) {
	const columns = [];
	let first = true;
	for (let property in obj) {
		let name = makeFirstLetterUpperCase(property);
		const item = {
			field: property,
			headerName: name,
			width: first ? 200 : 100,
		};
		columns.push(item);
		first = false;
	}
	return columns;
}

function makeFirstLetterUpperCase(str) {
	return str.charAt(0).toUpperCase() + str.slice(1);
}

function prepareCustomerTableRow(data) {
	let rows = [];

	for (let i = 0; i < data.length; ++i) {
		let item = data[i];
		let obj = { id: i, ...item };
		rows.push(obj);
	}
	return rows;
}

export function prepareCustomerMLCD(srcData) {
	let periods = getPeriods(srcData);
	let dataSources = getDataSources(srcData);
	let seriesData = [];
	for (let s = 0; s < dataSources.length; ++s) {
		const name = dataSources[s];
		let data = [];
		for (let i = 0; i < srcData.length; ++i) {
			if (srcData[i].series === name) {
				data.push(srcData[i].value);
			}
		}
		const item = {
			name,
			data,
		};
		seriesData.push(item);
	}
	const preparedData = {
		periods,
		seriesData,
	};
	return preparedData;
}

export function prepareCustomersIncExcTableData(data) {
	let preparedCustomerData = {};
	//console.log(data);
	const rows1 = prepareCustomersIncExcTableRow(data);
	const columns1 = prepareCustomersIncExcTableColumn();
	preparedCustomerData.rows1 = rows1;
	preparedCustomerData.columns1 = columns1;
	return preparedCustomerData;
}

export function prepareScenarioTableData(data) {
	let preparedData = {};
	const rows = prepareScenarioTableRow(data);
	const columns = prepareScenarioTableColumn();
	preparedData.rows = rows;
	preparedData.columns = columns;
	return preparedData;
}
export function prepareScenarioOtherInfoTableData(data) {
	let preparedScenarioOtherInfoData = {};
	//console.log("The other information",data);
}

function prepareScenarioTableColumn() {
	const columns = [
		{ field: "hierarchy", headerName: "Hierarchy", flex: 1, minWidth: 150 },
		{
			field: "scenarioName",
			headerName: "Scenario Name",
			flex: 1,
			minWidth: 150,
		},
		{
			field: "effectiveStartDate",
			headerName: "Effective Start Date",
			flex: 1,
			minWidth: 150,
		},
		{
			field: "effectiveEndDate",
			headerName: "Effective End Date",
			flex: 1,
			minWidth: 150,
		},
		{
			field: "originalEndDate",
			headerName: "Original End Date",
			flex: 1,
			minWidth: 150,
		},
		{ field: "createdBy", headerName: "Created By", flex: 1, minWidth: 150 },
		{ field: "updatedBy", headerName: "Updated By", flex: 1, minWidth: 150 },
		{
			field: "compare",
			headerName: "Compare",
			flex: 1,
			minWidth: 150,
			headerAlign: "center",
			align: "center",
			renderCell: (params) => (
				<input
					type="checkbox"
					onChange={(event) => handleCompareChange(event, params.row)}
					checked={params.row.compare || false} // Default to unchecked
					style={{ alignContent: "center" }}
				/>
			),
			headerClassName: "compare-header",
		},
	];
	return columns;
}

function handleCompareChange(event, row) {
	const isChecked = event.target.checked;
	//console.log(`Row:`, row, `Checked:`, isChecked);
}
function prepareCustomersIncExcTableColumn() {
	const columns = [
		{
			field: "customerName",
			headerName: "Customer Name",
			flex: 1,
			minWidth: 150,
		},
		{
			field: "customerNumber",
			headerName: "Customer Number",
			flex: 1,
			minWidth: 150,
		},
		{
			field: "clientCustomerCode",
			headerName: "Client Customer Code",
			flex: 1,
			minWidth: 150,
		},
		{
			field: "validFromDate",
			headerName: "Valid From Date",
			flex: 1,
			minWidth: 150,
		},
		{
			field: "validToDate",
			headerName: "Valid To Date",
			flex: 1,
			minWidth: 150,
		},
		{
			field: "validToDate_Cloning",
			headerName: "Valid due to Cloning",
			flex: 1,
			minWidth: 150,
		},
	];
	return columns;
}

function prepareCustomersIncExcTableRow(data) {
	let rows = [];

	for (let i = 0; i < data?.length; ++i) {
		let customer = data[i];
		const {
			clientCustomerCode,
			customerId,
			customerName,
			customerNumber,
			difference,
			validFromDate,
			validToDate,
			validToDate_Cloning,
		} = customer;
		const obj = {
			id: customerId,
			clientCustomerCode,
			customerName,
			customerNumber,
			validFromDate: formatDate(validFromDate),
			validToDate: formatDate(validToDate),
			validToDate_Cloning: formatDate(validToDate_Cloning),
			difference,
		};
		rows.push(obj);
	}
	return rows;
}

function prepareScenarioTableRow(data) {
	let rows = [];

	for (let i = 0; i < data?.length; ++i) {
		let scenario = data[i];
		const {
			scenarioID,
			hierarchy,
			scenarioName,
			effectiveStartDate,
			effectiveEndDate,
			originalEndDate,
			createdBy,
			updatedBy,
		} = scenario;
		const obj = {
			id: scenarioID,
			hierarchy,
			scenarioName,
			effectiveStartDate: formatDate(effectiveStartDate),
			effectiveEndDate: formatDate(effectiveEndDate),
			originalEndDate: formatDate(originalEndDate),
			createdBy,
			updatedBy,
		};
		rows.push(obj);
	}
	return rows;
}

export function prepareQuotaDetailsTableData(data) {
	const rows = prepareQuotaDetailsTableRow(data);
	const columns = prepareQuotaDetailsTableColumn();
	return {
		rows,
		columns,
	};
}

function prepareQuotaDetailsTableColumn() {
	const columns = [
		{
			field: "scenarioName",
			headerName: "Scenario Name",
			flex: 2,
			minWidth: 150,
			renderHeader: (params) => {
				return (
				  <div>
					<strong>Scenario Name</strong>
				  </div>
				);
			  },			
		},
		{
			field: "sku",
			headerName: "SKU Description",
			flex: 2,
			minWidth: 150,
			valueGetter: (params) => {
				if (params.row.skuName && params.row.skuName !== "") {
					return `${params.row.skuName} (${params.row.skuNumber})`;
				}
				return "";
			},
		},
		{
			field: "customer",
			headerName: "Customer Description",
			flex: 2,
			minWidth: 150,
			valueGetter: (params) => {
				if (params.row.customerName && params.row.customerName !== "") {
					return `${params.row.customerName} (${params.row.customerNumber})`;
				}
				return "";
			},
		},
		{
			field: "depletionModel",
			headerName: "Depletion Type",
			flex: 1,
			minWidth: 120,
			valueGetter: (params) =>
				params.row.depletionModel ?? "",
		},
		{
			field: "quota",
			headerName: "Quota",
			flex: 1,
			minWidth: 150,
		},
		{
			field: "efs",
			headerName: "EFS",
			flex: 1,
			minWidth: 150,
		},
		{
			field: "consumption",
			headerName: "Consumption",
			flex: 1,
			minWidth: 150,
      valueGetter: (params) => {
        return `${params.row.consumption}%`;
      }
		},
	];
	return columns;
}

function prepareQuotaDetailsTableRow(data) {
	let rows = [];
	for (let i = 0; i < data.length; ++i) {
		const obj = {
			id: i,
			...data[i],
		};
		rows.push(obj);
	}
	return rows;
}

export function getLastNMonths(n) {
	const months = [
		"Jan",
		"Feb",
		"Mar",
		"Apr",
		"May",
		"Jun",
		"Jul",
		"Aug",
		"Sep",
		"Oct",
		"Nov",
		"Dec",
	];
	const currentDate = new Date();
	const result = [];

	for (let i = 0; i <= n; i++) {
		const year = currentDate.getFullYear();
		const monthIndex = currentDate.getMonth();
		const month = months[monthIndex];
		result.push(`${month} ${year}`);
		currentDate.setMonth(currentDate.getMonth() - 1);
	}

	return result.reverse();
}

export function getListOfCustomers(data) {
	if (!_.isEmpty(data)) {
		let customers = [];
		const month = data[0]?.period;
		customers.push({ name: data[0]?.series, id: data[0]?.customerID });
		for (let i = 1; i < data?.length; ++i) {
			if (data[i]?.period === month) {
				const obj = {
					name: data[i]?.series,
					id: data[i]?.customerID,
				};
				customers.push(obj);
			} else break;
		}
		return customers;
	}
}

export function getListOfCustomers2(data) {
	if (!_.isEmpty(data)) {
		let customers = [];
		const month = data[0]?.period;
		customers.push({ name: data[0]?.customerName, id: data[0]?.customerId });
		for (let i = 1; i < data?.length; ++i) {
			if (data[i]?.period === month) {
				const obj = {
					name: data[i]?.customerName,
					id: data[i]?.customerId,
				};
				customers.push(obj);
			} else break;
		}
		return customers;
	}
}

export function getLineChartDataForCustomer(customerData, customer) {
	let data = [];
	for (let i = 0; i < customerData.length; i++) {
		if (customerData[i].series === customer) {
			data.push(customerData[i].value);
		}
	}
	return [{ name: customer, data }];
}

export function getTableDataForCustomer(customerData, n) {
	const rows = getRowDataForCustomer(customerData, n);
	const columns = getColumnDataForCustomer(n);
	return {
		rows,
		columns,
	};
}

function getColumnDataForCustomer(n) {
	let columns = [
		{
			field: "customerName",
			headerName: "Customer Name",
		},
		{
			field: "relationshipLevel",
			headerName: "Relationship Level",
		},
	];

	const monthsHeader = getLastNMonths(n);
	const monthsField = monthsHeader.map((month) => {
		return month.toLowerCase();
	});

	for (let i = 0; i < monthsHeader.length; ++i) {
		const obj = {
			field: monthsField[i],
			headerName: monthsHeader[i],
		};
		columns.push(obj);
	}
	columns.push({
		field: "details",
		headerName: "Details",
	});

	return columns;
}

function getRowDataForCustomer(customerData, n) {
	let rows = [];
	const monthsHeader = getLastNMonths(n);
	const monthsField = monthsHeader.map((month) => {
		return month.toLowerCase();
	});

	if (customerData !== undefined) {
		for (let i = 0; i < customerData?.length; ++i) {
			const obj = {
				id: customerData[i]?.customerId,
				customerName: customerData[i]?.customerName,
				relationshipLevel: customerData[i]?.relationshipLevel,
			};
			for (let j = 0; j < monthsField?.length; ++j) {
				obj[monthsField[j]] = customerData[i][monthsField[j]];
			}
			obj["details"] = customerData[i]?.details;
			rows.push(obj);
		}
		return rows;
	} else return rows;
}

export function prepareModificationsMLCD(data) {
	const customers = getListOfCustomers(data);
	let seriesData = [];

	for (let c = 0; c < customers?.length; ++c) {
		const customer = customers[c];
		let values = [];
		for (let i = 0; i < data.length; ++i) {
			if (data[i].series === customer.name) {
				values.push(data[i].value);
			}
		}

		const item = {
			name: customer.name,
			data: values,
		};
		seriesData.push(item);
	}

	return seriesData;
}

export function prepareModificationsTD(data) {}

export function saveResponseAsJsonFile(data, fileName) {
	const jsonString = JSON.stringify(data, null, 3);
	const blob = new Blob([jsonString], { type: "application/json" });
	const downloadLink = document.createElement("a");
	downloadLink.href = URL.createObjectURL(blob);
	downloadLink.download = `${fileName}.json`;
	downloadLink.click();
}

function isDistinctEnough(color, colors, threshold) {
	return colors.every((existingColor) => {
		const diff =
			parseInt(color.substring(1), 16) -
			parseInt(existingColor.substring(1), 16);
		return Math.abs(diff) > threshold;
	});
}

export function getFourPLTableData(data) {
	const rows = getFourPLRowData(data);
	const columns = getFourPLColumnData();
	return {
		rows,
		columns,
	};
}

function getFourPLColumnData() {
	const columns = [
		{ field: "country", headerName: "Country", flex: 1, minWidth: 150 },
		{
			field: "customerName",
			headerName: "Customer Name",
			flex: 1,
			minWidth: 150,
		},
		{
			field: "customerNumber",
			headerName: "Customer Number",
			flex: 1,
			minWidth: 150,
		},
		{
			field: "customerType",
			headerName: "Customer Type",
			flex: 1,
			minWidth: 150,
		},
		{
			field: "customerGroupName",
			headerName: "Customer Group Name",
			flex: 1,
			minWidth: 150,
		},
		// {
		//   field: "customerGroupNumber",
		//   headerName: "Customer Group Number",
		//   flex: 1,
		//   minWidth: 150,
		// },
		{
			field: "partnerType",
			headerName: "Partner Type",
			flex: 1,
			minWidth: 150,
		},
		{
			field: "quota",
			headerName: "Quota",
			flex: 1,
			minWidth: 150,
			valueFormatter: (params) => {
				const formattedValue = params.value?.toLocaleString('en-US');
				return formattedValue;
			},
		},
		{
			field: "previousQuota",
			headerName: "Previous Period Quota",
			flex: 1,
			minWidth: 150,
			valueFormatter: (params) => {
				const formattedValue = params.value?.toLocaleString('en-US');
				return formattedValue;
			},
		},
		{
			field: "productNumber",
			headerName: "Product Number",
			flex: 1,
			minWidth: 150,
		},
		{
			field: "productName",
			headerName: "Product Name",
			flex: 1,
			minWidth: 150,
		},
		// {
		// 	field: "productGroupName",
		// 	headerName: "Product Group Name",
		// 	flex: 1,
		// 	minWidth: 150,
		// },
		// {
		//   field: "productGroupNumber",
		//   headerName: "Product Group Number",
		//   flex: 1,
		//   minWidth: 150,
		// },
		{ field: "startDate", headerName: "Start Date", flex: 1, minWidth: 150 },
		{ field: "endDate", headerName: "End Date", flex: 1, minWidth: 150 },
		{ field: "periodType", headerName: "Period Type", flex: 1, minWidth: 150 },
		{
			field: "depletionModelName",
			headerName: "Depletion Type",
			flex: 1,
			minWidth: 150,
			valueGetter: (params) =>
				params.row.depletionModelName ?? params.row.DepletionModelName ?? "",
		},
	];
	return columns;
}

function getFourPLRowData(data) {
	let rows = [];
	for (let i = 0; i < data.length; ++i) {
		const {
			country,
			customerName,
			customerNumber,
			customerType,
			customerGroupName,
			partnerType,
			quota,
			previousQuota,
			productNumber,
			productName,
			productGroupName,
			startDate,
			endDate,
			periodType,
			depletionModelName,
		} = data[i];
		const obj = {
			id: i,
			country,
			customerName,
			customerNumber,
			customerType,
			customerGroupName,
			partnerType,
			quota,
			previousQuota,
			productNumber,
			productName,
			productGroupName,
			startDate,
			endDate,
			periodType,
			depletionModelName: depletionModelName ?? "",
		};
		rows.push(obj);
	}
	return rows;
}
